import { baseUrl, handleResponse, handleError, PutOptions, GetHeaders } from "../common/ApiUtils";

const apiUrl = baseUrl + "Options/Plan";

export function createPlan(plan) {
    return fetch(`${apiUrl}/Create`, PutOptions(plan)).then(handleResponse).catch(handleError);
}

export function updatePlan(planid, plan)
{
    return fetch(`${apiUrl}/${planid}/Update`, PutOptions(plan)).then(handleResponse).catch(handleError);
}

export function getPlanMenu() {
    return fetch(`${apiUrl}/Menu`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getPlanList() {
    return fetch(`${apiUrl}/List`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getPlanTotals() {
    return fetch(`${apiUrl}/PlanTotals`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getPlanIssueGroupSummaries(planId) {
    return fetch(`${apiUrl}/GetPlanIssueGroupSummaries/${planId}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getPlan(planId) {
    return fetch(`${apiUrl}/Get/${planId}`, GetHeaders()).then(handleResponse).catch(handleError);
}

export function getStatement(planId) {
    return fetch(`${apiUrl}/${planId}/Statement`, GetHeaders()).then(handleResponse).catch(handleError);
}